import { Campaign, Status_Enum as CampaignStatus } from '@weave/schema-gen-ts/dist/schemas/messaging/bulk/v2';
import dayjs from 'dayjs';
import { BACKEND_DATE_TIME_FORMAT } from '../constants';
import { checkIsUnscheduled } from './check-is-unscheduled';

// TODO: Move this to a more general utility file since it is used elsewhere. Add unit tests.
export const isReadOnly = (campaign: Campaign | undefined) => {
  if (!campaign) return false;
  const isUnscheduled = checkIsUnscheduled(campaign?.currentStatus);
  const readOnlyStatuses = [
    CampaignStatus.CANCELED,
    CampaignStatus.COMPLETED,
    CampaignStatus.DELETED,
    CampaignStatus.PROCESSING,
  ];
  const startSendAtPlus15Minutes = dayjs(campaign?.startSendAt).add(15, 'minutes').format(BACKEND_DATE_TIME_FORMAT);
  const now = dayjs().format(BACKEND_DATE_TIME_FORMAT);
  const within15MinutesOrPast = startSendAtPlus15Minutes < now;
  // TODO: evaluate if we can simplify this logic (I think the isUnscheduled check is enough with maybe the scheduled within 15 minutes)
  const readOnly =
    !!(
      readOnlyStatuses.find((status) => status === campaign?.currentStatus) ||
      (campaign?.currentStatus === CampaignStatus.SCHEDULED && within15MinutesOrPast)
    ) && !isUnscheduled;
  return readOnly;
};
